/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 **/
export const ROUTE_RESOURCES = {
  API_DATA: 'api.data',
  API_AUTH: 'api.auth',
} as const;